import { render } from "./Card.vue?vue&type=template&id=5ad3343a&scoped=true"
import script from "./Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Card.vue?vue&type=script&setup=true&lang=js"

import "./Card.vue?vue&type=style&index=0&id=5ad3343a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad3343a"],['__file',"src/components/Wishlist/Card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad3343a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad3343a', __exports__)) {
    api.reload('5ad3343a', __exports__)
  }
  
  module.hot.accept("./Card.vue?vue&type=template&id=5ad3343a&scoped=true", () => {
    api.rerender('5ad3343a', render)
  })

}


export default __exports__